import React from 'react';
function ButtonIcon(_a) {
    var icon = _a.icon, id = _a.id;
    return (React.createElement("span", { className: "elmo-btn__icon", "data-testid": "elmo-btn-icon-" + (id || 'default') }, icon));
}
export default ButtonIcon;
